import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import BiSpan from '../../../../biLogger/Components/BiSpan';
import BiLink from '../../../../biLogger/Components/BiLink';
import { MenuItem } from '../../../../Menu';
import CheckIcon from '../../../../Icons/Check';
import { IconSize } from '../../../../Icons/IconWrap';
import StandardMenuItemLabel from '../StandardMenuItemLabel';
import StandardMenuSubmenu from '../StandardMenuSubmenu';
import s from './StandardMenuOption.scss';
function getComponentClassAndProps(item) {
    var componentClass = item.componentClass ? item.componentClass : BiSpan;
    var componentProps = item.componentProps || {};
    if (item.link) {
        return {
            componentClass: item.componentClass || BiLink,
            componentProps: __assign(__assign({}, componentProps), { href: item.link, target: item.target, title: item.title }),
        };
    }
    if (item.submenu) {
        return {
            componentClass: StandardMenuSubmenu,
            componentProps: __assign(__assign({}, componentProps), { submenu: item.submenu }),
        };
    }
    return {
        componentClass: componentClass,
        componentProps: componentProps,
    };
}
// TODO: this export is terrible and is only needed because Menu is awful
export function renderMenuOption(_a, key) {
    var item = _a.item, hideCheckIcon = _a.hideCheckIcon, withHoverEffect = _a.withHoverEffect, className = _a.className;
    var itemIcon = item.icon, iconClassName = item.iconClassName, onClick = item.onClick, disabled = item.disabled, danger = item.danger, itemClassName = item.className, value = item.value, selected = item.selected, label = item.label, biData = item.biData;
    var icon = null;
    if (itemIcon) {
        // ick
        icon = React.cloneElement(itemIcon, {
            className: classnames(s['menu-item-icon'], iconClassName),
        });
    }
    var _b = getComponentClassAndProps(item), componentClass = _b.componentClass, componentProps = _b.componentProps;
    return (React.createElement(MenuItem, { key: key, componentClass: componentClass, componentProps: componentProps, className: classnames(s['menu-item'], onClick && s['clickable'], disabled && s['disabled'], danger && s['danger'], withHoverEffect && s['with-hover-effect'], itemClassName, className), value: value, disabled: disabled, selected: selected, label: typeof label === 'string' ? label : undefined, onClick: onClick, biData: biData },
        icon,
        React.createElement(StandardMenuItemLabel, { item: item }),
        selected && !hideCheckIcon && (React.createElement(CheckIcon, { className: s['selected-icon'], size: IconSize.TINY }))));
}
var StandardMenuOption = function (props) {
    return renderMenuOption(props);
};
StandardMenuOption.displayName = 'StandardMenuOption';
export default StandardMenuOption;
//# sourceMappingURL=StandardMenuOption.js.map